/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleRender } from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";
import InputSelect from "../../inputs/InputSelect";
import { postAirport, updateAirport } from "../../../store/airports";
import SelectInput from "../../inputs/selectInput";

const UpdateAirports = ({ isOpen, toggleModal, setOpen }) => {
  //view pupup when onclick "اضافه مطار"
  const dispatch = useDispatch();
  const airportsId = useSelector((state) => state.airports.id);
  const airportsDetails = useSelector((state) => state.airports.airports);
  const errorMsgStore = useSelector((state) => state.airports.errorMsg);
  const [errorMsg, seterrorMsg] = useState(errorMsgStore);

  const [values, setValues] = useState({
    render: false,
    en_name: "",
    ar_name: "",
    status: "",
  });

  useEffect(() => {
    setValues({
      ...values,
      render: true,
      en_name: airportsDetails.name_en,
      ar_name: airportsDetails.name_ar,
      status: airportsDetails.status,
    });
  }, [airportsDetails]);

  // Handles file upload event and updates state
  const handleChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    });
    if (errorMsg !== null) {
      seterrorMsg({ ...errorMsg, [target.name]: null });
    }
  };
  //function to sumbit data
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateAirport({ ...values, id: airportsId })).then((res) => {
      if (res.payload.status === 200) {
        dispatch(toggleRender());
        setOpen(false);
        setValues({
          render: true,
          en_name: "",
          ar_name: "",
          status: "",
        });
      } else {
        setOpen(true);
        dispatch(toggleRender());
        setValues({ ...values, render: true });
      }
    });
  };
  //handel error
  useEffect(() => {
    seterrorMsg(errorMsgStore);
  }, [errorMsgStore]);
  const options = [
    {
      value: "active",
      label: "مفعل",
    },
    {
      value: "inactive",
      label: "غير مفعل ",
    },
  ];
  const handelError = (key) => {
    return (
      <span className='text-error'>
        {" "}
        {errorMsg !== null ? errorMsg[key] : null}{" "}
      </span>
    );
  };
  const handleSelect = (e) => {
    setValues({ ...values, status: e.value });
    if (errorMsg !== null && errorMsg !== undefined) {
      seterrorMsg({ ...errorMsg, status: null });
    }
  };

  return (
    <Popup viewPupup={isOpen} hidePupup={toggleModal} viewWidth='content-small'>
      <form className='main-contnt' onSubmit={handleSubmit}>
        <div className='body-content'>
          <SelectInput
            label='الحاله'
            placeholder={values.status === "active" ? "مفعل" : "غير مفعل"}
            name='status'
            options={options}
            handleSelect={handleSelect}
            note='*'
            status={values.status}
          />
          {handelError("status")}
          <InputField
            value={values.ar_name}
            name='ar_name'
            onChange={handleChange}
            title='الاسم بالعربي'
            placeholder='اكتب اسم المطار'
            note='*'
          />
          {handelError("name_ar")}

          <InputField
            value={values.en_name}
            name='en_name'
            onChange={handleChange}
            title='الاسم بلانجليزي'
            placeholder='اكتب اسم المطار'
            note='*'
          />
          {handelError("name_en")}
        </div>
        <div className='buttons-contnt display-flex center-flex '>
          <input value='اضافه' type='submit' class='btn btn__primary' />
          <div class='btn btn__danger' onClick={toggleModal}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default UpdateAirports;
